import { render, staticRenderFns } from "./safe-recorddetail.vue?vue&type=template&id=38f18699&scoped=true&"
import script from "./safe-recorddetail.vue?vue&type=script&lang=js&"
export * from "./safe-recorddetail.vue?vue&type=script&lang=js&"
import style0 from "./safe-recorddetail.vue?vue&type=style&index=0&id=38f18699&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f18699",
  null
  
)

export default component.exports